import { createTRPCClient, httpLink } from "@trpc/client";
import type { AuthenticationRouter } from "@puzzleini/authentication/contract";
import { env } from "../config/env";
import { authErrorMessage } from "./errors";

export function createAuthClient(
  baseURL: string,
  fetcher: typeof fetch = fetch,
) {
  return createTRPCClient<AuthenticationRouter>({
    links: [
      httpLink({
        url: `${new URL(baseURL).origin}/auth/trpc`,
        fetch: (url, options) =>
          fetcher(url, {
            ...options,
            credentials: "include",
            signal: AbortSignal.any([
              AbortSignal.timeout(15_000),
              ...(options?.signal ? [options.signal] : []),
            ]),
          }),
      }),
    ],
  });
}

export const authClient = createAuthClient(env.VITE_AUTH_URL);

// The auth service preserves upstream status codes inside its tRPC result.
export function authResponse<T>(response: {
  status: number;
  body?: unknown;
}): T {
  if (response.status >= 200 && response.status < 300)
    return response.body as T;
  const details =
    typeof response.body === "object" && response.body !== null
      ? response.body
      : {};
  throw Object.assign(
    new Error(authErrorMessage({ ...details, status: response.status })),
    details,
    {
      status: response.status,
      message: authErrorMessage({ ...details, status: response.status }),
    },
  );
}
